/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Passkey_RegisteredInputs */



/**
* | output |
* | --- |
* | "Passkey registered successfully!" |
*
* @param {Profile_Passkey_RegisteredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_passkey_registered = /** @type {((inputs?: Profile_Passkey_RegisteredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Passkey_RegisteredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Passkey enregistrée avec succès !")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Passkey registrado exitosamente!")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Passkey registrada com sucesso!")
	if (locale === "it") return /** @type {LocalizedString} */ ("Passkey registrata con successo!")
	return /** @type {LocalizedString} */ ("Passkey registered successfully!")
});